import { defineStore } from 'pinia'
export default defineStore({
  id: 'companyUserDataTable',
  persist: true,
  state: () => {
    return {
      isCompanyUserArchive: false
    }
  },
  actions: {
    setIsCompanyUserArchive: function (payload: any) {
      this.isCompanyUserArchive = payload
    }
  },
  getters: {
    getIsCompanyUserArchive: (state: any) => state.isCompanyUserArchive
  }
})
